exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 650px) {\r\n\r\n    .m-l-150 {\r\n        margin-left: 150px !important;\r\n    }\r\n}\r\n.w85 {\r\n    width : 85%;\r\n}\r\n\r\n.helpAlign {\r\n    font-size: 24px;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    padding: 0px;\r\n   color: rgba(245, 245, 245, 0.877);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/multi-role-screen/multi-role-screen.component.css
// module id = ../../../../../src/app/multi-role-screen/multi-role-screen.component.css
// module chunks = 0